"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainAdapter = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const hdwallet_core_1 = require("@shapeshiftoss/hdwallet-core");
const types_1 = require("@shapeshiftoss/types");
const ErrorHandler_1 = require("../../error/ErrorHandler");
const utils_1 = require("../../utils");
const CosmosSdkBaseAdapter_1 = require("../CosmosSdkBaseAdapter");
class ChainAdapter extends CosmosSdkBaseAdapter_1.CosmosSdkBaseAdapter {
    constructor(args) {
        super(args);
        this.supportedChainIds = ['cosmos:osmosis-1', 'cosmos:osmo-testnet-1'];
        this.chainId = this.supportedChainIds[0];
        const { chain, network } = (0, caip_1.fromChainId)(this.chainId);
        this.assetId = (0, caip_1.toAssetId)({
            chain,
            network,
            assetNamespace: 'slip44',
            assetReference: caip_1.ASSET_REFERENCE.Osmosis
        });
    }
    getType() {
        return types_1.ChainTypes.Osmosis;
    }
    getFeeAssetId() {
        return 'cosmos:osmosis-1/slip44:118';
    }
    async getAddress(input) {
        const { wallet, bip44Params = ChainAdapter.defaultBIP44Params } = input;
        const path = (0, utils_1.toPath)(bip44Params);
        const addressNList = (0, hdwallet_core_1.bip32ToAddressNList)(path);
        try {
            if ((0, hdwallet_core_1.supportsOsmosis)(wallet)) {
                const osmosisAddress = await wallet.osmosisGetAddress({
                    addressNList,
                    showDisplay: Boolean(input.showOnDevice)
                });
                if (!osmosisAddress) {
                    throw new Error('Unable to generate Osmosis address');
                }
                return osmosisAddress;
            }
            else {
                throw new Error('Wallet does not support Osmosis.');
            }
        }
        catch (error) {
            return (0, ErrorHandler_1.ErrorHandler)(error);
        }
    }
    async signTransaction(signTxInput) {
        try {
            const { txToSign, wallet } = signTxInput;
            if ((0, hdwallet_core_1.supportsOsmosis)(wallet)) {
                const signedTx = await wallet.osmosisSignTx(txToSign);
                if (!signedTx)
                    throw new Error('Error signing tx');
                return signedTx.serialized;
            }
            else {
                throw new Error('Wallet does not support Osmosis.');
            }
        }
        catch (err) {
            return (0, ErrorHandler_1.ErrorHandler)(err);
        }
    }
    async buildSendTransaction(
    // @ts-ignore: keep type signature with unimplemented state
    tx // eslint-disable-line @typescript-eslint/no-unused-vars -- Disable no-unused-vars lint rule for unimplemented methods
    ) {
        throw new Error('Method not implemented.');
    }
    async getFeeData(
    // @ts-ignore: keep type signature with unimplemented state
    input // eslint-disable-line @typescript-eslint/no-unused-vars -- Disable no-unused-vars lint rule for unimplemented methods
    ) {
        throw new Error('Method not implemented.');
    }
    async signAndBroadcastTransaction(
    // @ts-ignore: keep type signature with unimplemented state
    signTxInput // eslint-disable-line @typescript-eslint/no-unused-vars -- Disable no-unused-vars lint rule for unimplemented methods
    ) {
        throw new Error('Method not implemented.');
    }
}
exports.ChainAdapter = ChainAdapter;
ChainAdapter.defaultBIP44Params = {
    purpose: 44,
    coinType: 118,
    accountNumber: 0
};
